export function debounce(this: any, fn: any, delay: number, timeoutID: number | undefined, ...args: any[]) {
    clearTimeout(timeoutID);
    const that = this;
    timeoutID = window.setTimeout(() => {
        fn.apply(that, args);
    }, delay);

    return timeoutID;
}
